import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Card, Icon, Input, Col, Row, Select, Alert } from 'antd';
import { openNotification } from '../../util/notificaciones';
import CatalogoRequest from '../../services/Catalogo';
import FormArticulosPT from './FormArticulosPT';
import ArticulosPTRequest from '../../services/ArticulosPT';
import { get_id } from '../../util/IdUser';
import { esBarras, getSegmento } from '../../util/generics';
const { Option } = Select;


/**
 * Clase para ver el proceso de mostrar artículos
 */
export default class ArticulosPT extends Component {
    state = {
        esBarra: esBarras(),
        filterText: "",
        arrArticulos: [],
        selectedRowKeys: [],
        selectedRows: [],
        categoriaSelected: null,
        filtros: {
            externo: parseInt(this.props.match.params.externo),
            filtro: undefined,
            id_drives: undefined,
            page: undefined
        },
        cargando: false,
        paginacion: {},
        modalEstatus: false,
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        arrDrives: [],
        allDrives: [],
        regionSelected: null,
        sucursalSelected: null,
        plazaSelected: null,
        drivesSelected: [],
        disableDeleteFilters: true,
        disableApplyFilters: true,
        productoSelected: null,
        cargandoFallo: false,
        arrArticulosFallo: [],
        mostrarModalFallo: false,
        paginaSiguiente: 1,
        arrRowsSelected: [],
        roles: localStorage.getItem("role")?.split(","),
        editAct: false
    }

    // constructor(props) {
    //     super(props);
    // }

    /**
     * Comportamiento del componente al mostrar los productos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        const segmento = getSegmento()
        if (!segmento) {
            let state = { ...this.state }
            const location = {
                pathname: "/",
            }
            this.setState(state, this.props.history.push(location))
        } else {
            state.cargando = true;
            this.setState(state, () => {

                CatalogoRequest.CargarSitiosByUsuario(get_id()).then(response => {
                    state.allDrives = response.data.map(f => f.id);
                    state.arrDrives = response.data

                    if (state.arrDrives.length) {
                        state.arrDrives.unshift({ id: -1, plaza: 0, cr: 'TODOS', nombre: 'TODOS', plaza_nombre: 'TODOS' })
                    } else {
                        state.arrDrives.unshift({ id: -1, plaza: 0, cr: 'No hay resultados', nombre: 'No hay resultados', plaza_nombre: 'No hay resultados', disable: true })
                    }
                    state.cargando = false
                    this.setState(state)
                }).catch(err => {
                    this.setState({ cargando: false })
                    openNotification("Ha ocurrido un error al listar las regiones.", "Error", false)
                })
                /*
                CatalogoRequest.CargarRegiones()
                    .then(response => {
                        state.arrRegiones = response.data
                        state.arrRegiones.unshift({
                            id: 0,
                            nombre: "TODOS",
                            nombre_corto: "TODOS",
                            version: 1,
                            activo: true
                        })
                        state.cargando = false
                        this.setState(state)
                    }).catch(err => {
                        this.setState({ cargando: false })
                        openNotification("Ha ocurrido un error al listar las regiones.", "Error", false)
                    })
                */
            })
        }
    }


    /**
     * Funcion interna de ant para el manejo de los checkbox
     * 
     * @param: selectedRowKeys (la necesita ant): id de los renglones, selectedRows: toda la informacion del objeto seleccionado
     * @return: nada
     */
    onSelectChange = (selectedRowKeys, selectedRows) => {
        let flag = false;
        let rows = [...this.state.arrRowsSelected]
        if (selectedRows.length) {
            rows = rows.concat(selectedRows)
            let hash = {};
            rows = rows.filter(o => hash[o.idArticuloInventario] ? false : hash[o.idArticuloInventario] = true);
        }
        selectedRows.forEach(function (artcl) {
            if (artcl.valores.Editable === 0)
                flag = true;
        });
        this.setState({ selectedRowKeys, selectedRows, arrRowsSelected: rows, editAct: flag }, this.verifyRowsSelected);
    };

    /**
    * Funcion interna de ant para el manejo de los checkbox
    * @param: selectedRowKeys (la necesita ant): id de los renglones, selectedRows: toda la informacion del objeto seleccionado
    * @return: nada
    */
    verifyRowsSelected = () => {
        let state = { ...this.state }
        let articulos_finales = [];
        state.selectedRowKeys.forEach(item => {
            state.arrRowsSelected.forEach(obj => {
                if (obj.idArticuloInventario === item) articulos_finales.push(obj)
            })
        })
        state.selectedRows = articulos_finales;
        this.setState(state)
    }

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }

        state.paginaSiguiente = paginaSiguiente
        state.filtros.page = paginaSiguiente
        state.cargando = true
        let ruta = ArticulosPTRequest.ListarArticulosPT(state.filtros)
        this.setState(state, () => {
            ruta.then(response => {
                state.paginacion.current = paginaSiguiente
                state.arrArticulos = response.data.results
                state.cargando = false
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al listar los artículos.", "Error", false)
            })
        })
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        let buscar = false;

        if (value.trim() !== state.filterText.trim()) buscar = true
        state.filterText = value;
        state.filtros.filtro = value.trim() === "" ? undefined : value.trim()
        state.paginaSiguiente = 1
        this.setState(state);
        if (buscar) {
            clearTimeout(state.timer)
            state.timer = setTimeout(() => {
                this.filtrarBack();
            }, 1000);
        }
    }

    /**
     * Función que se encarga de hacer las peticion en el back para filtrar
     * por los siguientes valores : 
     * {empresa: int, categoria:int, 
     *  subcategoria:int estatus:bool, 
     *  categorizado:bool, 
     *  nombre/codigo:string/int
     *  }
     */
    filtrarBack = (info) => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }
        state.modalEstatus = false;
        state.filtros.plaza_id = state.plazaSelected;
        state.filtros.sucursal_id = state.sucursalSelected;
        state.filtros.region_id = state.regionSelected;
        if (state.drivesSelected[0] == "-1" && state.drivesSelected.length == 1) {
            state.filtros.drive_id = state.allDrives;
        } else {
            state.filtros.drive_id = state.drivesSelected;
        }
        state.filtros.page = state.paginaSiguiente;
        state.filtros.filtro = state.filterText.trim() === "" ? undefined : state.filterText.trim()
        state.cargando = true;
        let ruta = ArticulosPTRequest.ListarArticulosPT(state.filtros)
        this.setState(state, () => {
            ruta.then(response => {
                state.arrArticulos = response.data.results
                state.cargando = false
                state.paginacion = {
                    current: state.paginaSiguiente,
                    total: response.data.count,
                    onChange: this.handlePaginaChange,
                    pageSize: 100,
                    showTitle: false
                }
                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification(err?.response?.data?.cuerpo, "Error")
            })
        })
    }

    /**
     * Función para limpiar todos los filtros que han
     * sido manipulados por el usuario.
     * @param: nada
     * @return: nada
     */
    cleanFilters = () => {
        let state = { ...this.state }
        state.disableApplyFilters = true;
        state.disableDeleteFilters = true;
        state.filtros.filtro = undefined;
        state.filtros.id_drives = undefined
        state.filtros.page = 1;
        state.filterText = "";
        state.selectedRowKeys = [];
        state.selectedRows = [];
        state.regionSelected = null;
        state.arrSucursales = [];
        state.sucursalSelected = null;
        state.arrPlazas = [];
        state.plazaSelected = null;
        state.arrDrives = [];
        state.drivesSelected = [];
        state.arrArticulos = [];
        state.paginacion = {
            current: 0,
            total: 0,
            onChange: this.handlePaginaChange,
            pageSize: 0,
            showTitle: false
        }
        this.setState(state);
        openNotification("Los filtros se han limpiado correctamente.", "Éxito", true);
    }

    /**
     * Función que muestra el modal de estatus
     * @param: nada.
     * @return: nada.
     */
    showModal = () => {
        this.setState({ modalEstatus: true })
    }

    editableStatus = () => {
        let state = { ...this.state }
        if (state.selectedRows.length > 0) {
            state.selectedRows.forEach(function (number) {
                if (number.valores.Editable === 0)
                    return true;
            });
        } else {
            return false;
        }
    }

    /**
     * Función que esconde el modal de estatus
     * @param: value. valor para esconder el modal
     * @return: nada.
     */
    esconderModal = (value, data) => {
        let state = { ...this.state }
        if (value) {
            state.modalEstatus = false;
            state.selectedRows = [];
            state.selectedRowKeys = [];
            state.productoSelected = null;
            this.setState(state, () => {
                this.filtrarBack(data)
            })
        }
        this.setState({ modalEstatus: false, productoSelected: null })
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeRegion = (value) => {
        let state = { ...this.state }
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.drivesSelected = [];
        state.arrArticulos = [];
        state.selectedRowKeys = [];
        state.selectedRows = [];
        state.filtros.id_drives = [];
        state.filterText = "";
        state.filtros.filtro = "";
        state.paginacion = {
            current: 0,
            total: 0,
            onChange: this.handlePaginaChange,
            pageSize: 0,
            showTitle: false
        }
        state.disableApplyFilters = true
        if (value === undefined) {
            state.regionSelected = null;
            state.disableDeleteFilters = true
        } else {
            state.regionSelected = value
            CatalogoRequest.CargarSucursalesRegion(value).then(response => {
                state.arrSucursales = response.data
                state.disableDeleteFilters = false
                if (state.arrSucursales.length) {
                    state.arrSucursales.unshift({
                        id: 0,
                        nombre: "TODOS",
                        numero: "000",
                        region: 0
                    });
                } else {
                    state.arrSucursales.unshift({
                        id: 0,
                        nombre: "No hay resultados",
                        numero: "000",
                        region: 0,
                        disable: true
                    });
                }
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la sucursal
     * @param: value. valor del id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        state.plazaSelected = null;
        state.drivesSelected = [];
        state.arrArticulos = [];
        state.selectedRowKeys = [];
        state.selectedRows = [];
        state.filtros.id_drives = [];
        state.filterText = "";
        state.filtros.filtro = "";
        state.paginacion = {
            current: 0,
            total: 0,
            onChange: this.handlePaginaChange,
            pageSize: 0,
            showTitle: false
        }
        state.disableApplyFilters = true
        if (value === undefined) {
            state.sucursalSelected = null;
        } else {
            state.sucursalSelected = value
            CatalogoRequest.ListarPlazasSucursal(value, state.regionSelected).then(response => {
                state.arrPlazas = response.data
                if (state.arrPlazas.length) {
                    state.arrPlazas.unshift({
                        id: -1,
                        nombre: 'TODOS',
                        sucursal: 0,
                        zona_horaria: null
                    });
                } else {
                    state.arrPlazas.unshift({
                        id: -1,
                        nombre: 'No hay resultados.',
                        sucursal: 0,
                        zona_horaria: null,
                        disable: true
                    });
                }
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las plazas de la sucursal.",
                    "Error",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    handleChangePlaza = (value) => {
        let state = { ...this.state }
        state.drivesSelected = [];
        state.arrArticulos = [];
        state.selectedRowKeys = [];
        state.selectedRows = [];
        state.filtros.id_drives = [];
        state.filterText = "";
        state.filtros.filtro = "";
        state.paginacion = {
            current: 0,
            total: 0,
            onChange: this.handlePaginaChange,
            pageSize: 0,
            showTitle: false
        }
        state.disableApplyFilters = true
        if (value === undefined) {
            state.plazaSelected = null;
        } else {
            state.plazaSelected = value
            CatalogoRequest.CargarSitiosPlaza(value, state.regionSelected, state.sucursalSelected, state.plaza).then(response => {
                state.arrDrives = response.data
                if (state.arrDrives.length) {
                    state.arrDrives.unshift({ id: -1, plaza: 0, cr: 'TODOS', nombre: 'TODOS', plaza_nombre: 'TODOS' })
                } else {
                    state.arrDrives.unshift({ id: -1, plaza: 0, cr: 'No hay resultados', nombre: 'No hay resultados', plaza_nombre: 'No hay resultados', disable: true })
                }
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar los drives de la plaza.",
                    "Error",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función cuando se cambia el combo de drive
     * @param: value. valor del id del drive
     * @return: nada.
     */
    handleChangeDrive = (value) => {
        let state = { ...this.state }
        state.arrArticulos = [];
        state.selectedRowKeys = [];
        state.selectedRows = [];
        state.filterText = "";
        state.filtros.filtro = "";
        state.paginacion = {
            current: 0,
            total: 0,
            onChange: this.handlePaginaChange,
            pageSize: 0,
            showTitle: false
        }
        if (!value.length) {
            state.drivesSelected = [];
            state.filtros.id_drives = [];
            state.disableApplyFilters = true;
        } else {
            state.drivesSelected = value
            state.filtros.id_drives = value
            state.disableApplyFilters = false;
        }

        this.setState(state)
    }

    render() {
        const drives = this.state.drivesSelected;
        const responsive = window.innerWidth <= 800
        let columnasArticulosTemp = [
            {
                title: "Código",
                dataIndex: "codigoProveedor",
                key: "codigoProveedor",
                width: 100,
                show: true
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                width: responsive ? 150 : null,
                show: true
            },
            {
                title: "UDMP",
                dataIndex: "unidad",
                key: "unidad",
                width: 90,
                show: true
            },
            {
                title: "Estatus",
                dataIndex: "activo",
                key: "activo",
                width: 100,
                show: drives.length == 1 && !this.state.drivesSelected.includes(-1),
                render: (_, record) => (
                    <>
                        {record.valores.Activo === true ? 'Activo' : 'Inactivo'}
                    </>
                )
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                width: 100,
                show: true,
                render: (value, record) => (
                    <div >
                        {
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Editar artículo"}>
                                    <Button
                                        id="boton-editar-estatus-producto-form"
                                        icon="edit"
                                        className="btnEditar"
                                        onClick={() => {
                                            this.setState({
                                                productoSelected: record,
                                                modo: "uno",
                                            }, this.showModal())
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                        }

                    </div>
                )
            }
        ]
        let columnasArticulos = columnasArticulosTemp.filter(obj => obj.show === true)
        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            hideDefaultSelections: true,
            selections: [
                {
                    key: 'all-data',
                    text: 'Seleccionar todo',
                    onSelect: () => {
                        this.setState({
                            selectedRowKeys: this.state.arrArticulos.map(item => item.idArticuloInventario),
                            selectedRows: [...this.state.arrArticulos]
                        });
                    },
                },
                {
                    key: 'un-select-all',
                    text: 'Deseleccionar todo',
                    onSelect: changableRowKeys => {
                        this.setState({ selectedRowKeys: [], selectedRows: [] });
                    },
                },
            ],
        };

        return (
            <Card id="ParentSize"
                title={("Artículos " + (this.state.filtros.externo === 1 ? "" : "internos"))}
                extra={
                    <Button
                        type="primary"
                        id="boton-editar-estatus-articulos"
                        disabled={!this.state.selectedRowKeys.length}
                        onClick={() => {
                            this.setState({
                                modo: "varios",
                            }, this.showModal())
                        }}
                    >
                        Editar Artículos
                    </Button>
                }>
                
                <Row gutter={24} style={{ marginBottom: "20px" }}>
                    <Col span={24}>
                        <Alert
                            description={<span style={{fontSize: "14px", fontWeight: "bold"}}>
                                {`No se guardará la configuración de Artículos para ${this.state.esBarra ? 'una barra' : 'un Drive'} si cuenta con un inventario no Finalizado el día de hoy.`}
                            </span>}
                            type="info"
                            icon={<Icon type="exclamation-circle" style={{ color: 'rgb(253, 135, 0)' }} />}
                            showIcon
                        />
                    </Col>
                </Row>

                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={24}>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                {
                                    this.state.segmento === 1 ? <div className="center">Drive:</div> : <div className="center">Barra:</div>
                                }
                                <div style={{display: "flex", alignItems: "center"}}>
                                <Tooltip
                                    placement="top"
                                    title={this.state.esBarra ? "Seleccione barra" : "Seleccione drive"}>
                                    <Select
                                        id="select-drive-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        mode="multiple"
                                        onChange={this.handleChangeDrive}
                                        value={this.state.drivesSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrDrives.length > 0 &&
                                            this.state.arrDrives.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}
                                                        disabled={obj.disable}>

                                                        {obj.plaza_prefijo ? obj.plaza_prefijo + " - " + obj.nombre : obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                                &nbsp;
                                <Tooltip placement="top" title={this.state.drivesSelected.length ? "Realizar búsqueda" : ""}>
                                    <Button
                                        id="boton-filtrar-productos-filtros"
                                        shape='circle'
                                        size='large'
                                        className={this.state.disableApplyFilters ? "disableBtn" : ""}
                                        type={this.state.disableApplyFilters ? "default" : "primary"}
                                        icon="search"
                                        onClick={() => {
                                            this.setState({ paginaSiguiente: 1 }, this.filtrarBack)
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                                </div>
                                
                            </Col>
                            {
                                /*
                                    <Col span={2}>
                                        <Tooltip placement="top" title="Borrar filtros">
                                            <Button
                                                id="boton-borrar-filtros-productos-tabla"
                                                type="default"
                                                icon="delete"
                                                className={this.state.disableDeleteFilters ? 'disableBtn' : ''}
                                                style={{ width: '80%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.7em' }}
                                                onClick={this.cleanFilters}
                                            >
                                            </Button>
                                        </Tooltip>
                                    </Col>
                                    <Col span={4}>
                                        <div className="center">Región:</div>
                                        <Tooltip
                                            placement="top"
                                            title="Seleccione una región">
                                            <Select
                                                id="select-region-productos-modulo"
                                                showSearch
                                                autoFocus={true}
                                                style={{ width: "100%" }}
                                                defaultActiveFirstOption={false}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                optionFilterProp="children"
                                                onChange={this.handleChangeRegion}
                                                value={this.state.regionSelected}
                                            >
                                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrRegiones.length > 0 &&
                                                    this.state.arrRegiones.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj.id}
                                                                value={obj.id}
                                                                disabled={obj.disable}>
                                                                {obj.nombre_corto}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        </Tooltip>
                                    </Col>
                                    <Col span={4}>
                                        <div className="center">Sucursal:</div>
                                        <Tooltip
                                            placement="top"
                                            title="Seleccione una sucursal">
                                            <Select
                                                id="select-sucursal-productos-modulo"
                                                showSearch
                                                style={{ width: "100%" }}
                                                defaultActiveFirstOption={false}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                optionFilterProp="children"
                                                disabled={this.state.regionSelected === null ? true : false}
                                                onChange={this.handleChangeSucursal}
                                                value={this.state.sucursalSelected}
                                                allowClear
                                            >
                                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrSucursales.length > 0 &&
                                                    this.state.arrSucursales.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj.id}
                                                                value={obj.id}
                                                                disabled={obj.disable}>

                                                                {obj.nombre}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        </Tooltip>
                                    </Col>
                                    <Col span={4}>
                                        <div className="center">Plaza:</div>
                                        <Tooltip
                                            placement="top"
                                            title="Seleccione una plaza">
                                            <Select
                                                id="select-plaza-calendario-modulo"
                                                showSearch
                                                style={{ width: "100%" }}
                                                defaultActiveFirstOption={false}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                optionFilterProp="children"
                                                disabled={this.state.sucursalSelected === null ? true : false}
                                                onChange={this.handleChangePlaza}
                                                value={this.state.plazaSelected}
                                                allowClear
                                            >
                                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrPlazas.length > 0 &&
                                                    this.state.arrPlazas.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj.id}
                                                                value={obj.id}
                                                                disabled={obj.disable}>

                                                                {obj.nombre}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        </Tooltip>
                                    </Col>
                                */
                            }

                        </Row>
                        <Row gutter={24}>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <div className="center">Búsqueda:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar por Código / Nombre ">
                                    <Input
                                        style={{width: "100%"}}
                                        maxLength={50}
                                        id="input-buscar-articulos-tabla-productos"
                                        placeholder="Buscar por Código / Nombre"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                        value={this.state.filterText}
                                        disabled={this.state.drivesSelected.length ? false : true}
                                    />
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>

                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <div style={{ height: '500px' }}>
                            <Table size="small"
                                locale={{ emptyText: 'No se han encontrado resultados' }}
                                rowKey={articulo => articulo.idArticuloInventario}
                                columns={columnasArticulos}
                                dataSource={this.state.arrArticulos}
                                rowSelection={rowSelection}
                                scroll={{ y: 450, x: 300 }}
                                pagination={{
                                    ...this.state.paginacion,
                                    onChange: (page, pageSize) => {
                                        this.handlePaginaChange(page)
                                        const tabla = document.querySelector('.ant-table-body');
                                        if (tabla) {
                                            tabla.scrollTop = 0;
                                        }
                                    }
                                }}
                            />
                        </div>
                    </Spin>
                </div>
                <FormArticulosPT
                    esconderModal={this.esconderModal}
                    visible={this.state.modalEstatus}
                    drivesSelected={drives}
                    modo={this.state.modo}
                    producto_selected={this.state.productoSelected}
                    arrArticulos={this.state.selectedRows}
                    externo={this.state.filtros.externo}
                    disabledStatus={this.state.editAct}
                />
            </Card>
        )
    }
}